import React, { Component } from "react";
import { Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';

import Close from '../../../assets/images/close.svg';
import trialIcon from '../../../assets/images/trial-icon.svg';
import { downloadTrials } from '../AccountsActions';

class ExportTrialConfig extends Component{
    constructor(props){
        super(props);
        const todayIsEarlierThenWednesday = moment().weekday() < 2;
        const thisWednesday = moment().startOf('W').add(2,'day').endOf('day');
        const lastWednesday = todayIsEarlierThenWednesday ? thisWednesday.add(-7, 'day'): thisWednesday;
        const lastWednesdayString = lastWednesday
                                            .set('seconds', 0)
                                            .set('milliseconds', 0)
                                            .format('DD MMM YYYY HH:mm')
        const prevThursday = moment(lastWednesday).add(-6,'day').startOf('day');
        this.state = {
            isOpened: props.visible,
            value: { 
                from: prevThursday
                        .set('seconds', 0)
                        .set('milliseconds', 0)
                        .format('DD MMM YYYY HH:mm'),
                to: lastWednesdayString
            }
        };
    }

    onButtonClick = () => {
        if (!this.state.isOpened) {
            this.setState({ isOpened: true });
        }
    }

    onClose = (event) => {
        if (event) {
          event.stopPropagation();
        }
        this.setState({ isOpened: false });
    
        if (typeof this.props.onClose === 'function') {
          this.props.onClose();
        }
      };
    
      onConfirm = (event) => {
        event.stopPropagation();
    
        this.props
          .downloadTrials(this.state.value.from, this.state.value.to)
          .then(() => {
            if (typeof this.props.onClose === 'function') {
              this.props.onClose(true);
            }
          })
          .catch(() => {});
      };

    handleDateTimeChange = (field, date) => {
        this.setState({
          value: {
            ...this.state.value,
            [field]: date ? moment(date).format('DD MMM YYYY HH:mm') : '',
          },
        });
    };
      

    render(){
        const { isOpened, value } = this.state;
        const modal = 
        (<Modal     
            show={isOpened}
            onHide={this.onClose}
            keyboard={this.props.keyboard}
            backdrop={this.props.backdrop}
            enforceFocus={this.props.enforceFocus}>
            <Modal.Header>
              <Modal.Title>Set Export Dates</Modal.Title>
              <Button variant="close" onClick={this.onClose}>
                <img src={Close} alt="close" />
              </Button>
            </Modal.Header>
                <Modal.Body>
                <Form onSubmit={this.handleSubmit}>
                    <Row className="export-trail">
                        <Col sm={6}>
                        <FormGroup controlId="range-start">
                            <label>Starts on</label>
                            <DateTimePicker
                              value={moment(value.from, 'DD MMM YYYY HH:mm').toDate()}
                              onChange={(date) => this.handleDateTimeChange('from', date)}
                              format="dd MMM yyyy HH:mm"
                              disableClock
                            />
                        </FormGroup>
                        </Col>
                        <Col sm={6}>
                        <FormGroup controlId="range-end">
                            <label>Ends on</label>
                            <DateTimePicker
                              value={moment(value.to, 'DD MMM YYYY HH:mm').toDate()}
                              onChange={(date) => this.handleDateTimeChange('to', date)}
                              format="dd MMM yyyy HH:mm"
                              disableClock
                            />
                        </FormGroup>
                        </Col>
                    </Row>
                </Form>
                </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={this.onConfirm} disabled={!this.state.value.from || !this.state.value.to}>
                    <img src={trialIcon} alt="#" /> Define Dates
                </Button>
                <Button variant="secondary" onClick={this.onClose}>
                    Close
                </Button>                
            </Modal.Footer>
        </Modal>);
        
        let content;
        if (this.props.children) {
            var btn = React.Children.only(this.props.children);
            content = React.cloneElement(
            btn,
            {
                onClick: this.onButtonClick,
                style: this.props.style,
            },
            btn.props.children,
            modal
            );
        } else {
            content = (
            <Button onClick={this.onButtonClick} style={this.props.style}>
                {this.props.buttonText}
                {modal}
            </Button>
            );
        }
        return content;      
    }
}

ExportTrialConfig.propTypes = {
    buttonText: PropTypes.node,
    onClose: PropTypes.func,
    visible: PropTypes.bool,
  };

const mapDispatchToProps = (dispatch, props) => {
  return {
    downloadTrials: (startDate, endDate) => dispatch(downloadTrials(startDate, endDate)),
  };
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExportTrialConfig);